import React from "react";

function BookingForm({ title, onSubmit, submitText, children }) {
  return (
    <div className="p-8 border rounded-lg shadow-2xl bg-slate-800/70 backdrop-blur-xl md:p-10 border-slate-700/50">
      <h2 className="mb-8 text-3xl font-bold text-white md:text-4xl">{title}</h2>

      <form onSubmit={onSubmit} className="space-y-5">
        {children}

        <button
          type="submit"
          className="w-full bg-[#f5272b] hover:bg-red-600 text-white font-bold text-lg py-4 rounded-sm transition-all duration-300 transform hover:scale-[1.02] shadow-lg hover:shadow-xl uppercase mt-2"
        >
          {submitText}
        </button>
      </form>
    </div>
  );
}

export default BookingForm;
